import type { SupportTicketStatusChangedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import StatusIcon from "@redotech/redo-icons/status.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const SupportTicketStatusChangedEvent = memo(
  function SupportTicketStatusChangedEvent({
    event,
    data,
  }: {
    event: SupportTicketTimelineEventResponse;
    data: SupportTicketStatusChangedEventData;
  }) {
    const title = `Status changed from ${formatSentenceCase(data.previousStatus)} to ${formatSentenceCase(data.newStatus)}`;

    return (
      <Flex align="flex-start" className={styles.card} gap="sm">
        <Flex
          align="center"
          className={`${styles.icon} ${styles.iconBlue}`}
          justify="center"
        >
          <StatusIcon />
        </Flex>
        <Flex className={styles.content} dir="column" gap="xxs">
          <Text fontSize="xs" fontWeight="medium" textColor="primary">
            {title}
          </Text>
          {data.reason && (
            <Text
              className={styles.details}
              fontSize="xxs"
              textColor="secondary"
            >
              {data.reason}
            </Text>
          )}
          <EventTimestamp event={event} />
        </Flex>
      </Flex>
    );
  },
);
